import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import { useMediaQuery } from '@mui/material';

/**
 * @param {Object} props
 * @param {string} props.urlParamKey - URL parameter key for card IDs
 * @param {Function} props.cardComponent - Card component to render
 */
function CardDisplay(props) {
  const { search } = useLocation();
  const {
    cardComponent: CardComponent,
    urlParamKey,
  } = props;
  const [componentIds, setComponentIds] = useState([]);
  const isMaxWidth = useMediaQuery('(max-width: 2000px)');

  useEffect(() => {
    const newIds = [];
    // TODO: may need to extract this search usage
    const paramValues = new URLSearchParams(search).getAll(urlParamKey);
    paramValues.forEach((value) => {
      const existing = !!(componentIds.find((id) => (id === value
        || id === parseInt(value, 10))));
      if (!existing) newIds.push(value);
    });

    const remainingIds = [];
    componentIds.forEach((value) => {
      const remain = paramValues.find((id) => (id === value
        || id === parseInt(value, 10)));
      if (remain) remainingIds.push(value);
    });
    if (newIds.length > 0 || remainingIds.length !== componentIds.length) {
      setComponentIds([...newIds, ...remainingIds]);
    }
  }, [componentIds, search, urlParamKey]);

  return (
    <Grid container size={12} rowSpacing={1} columnSpacing={{ xs: 1 }}>
      {componentIds.map((id) => (
        <Grid key={`card-${id}`} size={{ xs: 12, lg: 6, xl: (isMaxWidth ? 4 : 3) }}>
          <CardComponent key={`card-component-${id}`} id={id} />
        </Grid>
      )) }
    </Grid>
  );
}

export default CardDisplay;
